import { useTranslation } from 'react-i18next';

import Security from 'src/assets/undraw_security.svg';

export const NoConrepRole = () => {
  const { t } = useTranslation(['conrep', 'project']);

  return (
    <div className="rounded border border-dashed border-gray-300">
      <div className="mx-auto max-w-[640px] p-8 text-center">
        <img src={Security} alt="" className="mx-auto h-[160px]" />
        <h1 className="mb-4 mt-8 text-4xl font-semibold">
          {t('conrep:settings.noRole.noAccess')}
        </h1>
        <p className="mb-6 text-shuttleGray-600">
          {t('conrep:settings.noRole.noRole')}
        </p>
      </div>
    </div>
  );
};
